<template>
  <main class="content container text-page" id="withdrawalContainer">
    <div class="container">
      <a class="back-link" href="javascript:history.back();">
        <i class="icon icon-sm icon-arrow-left"></i> {{ $t('cs.front.back') }}
      </a>
      <section class="page-view">
        <h1>{{ $t('cs.front.withdrawal_header') }}</h1>

        <div v-if="step === 1 || !step">
            <div>
              <p>{{ $t('cs.front.withdrawal_top_text') }}</p>
            </div>
            <div>
              <div>
                <label>
                  {{ $t('cs.front.withdrawal_form_name') }}<br />
                  <input v-model="orderParams.client_name" type="text" >
                </label>
              </div>
              <div>
                <label>
                  {{ $t('cs.front.withdrawal_form_order_number') }}<br />
                  <input v-model="orderParams.number" type="text" :placeholder="`VS-${currentYear}-123456`">
                </label>
              </div>
              <div>
                <label>
                  {{ $t('cs.front.withdrawal_form_email') }}<br />
                  <input v-model="orderParams.email" type="email" >
                </label>
              </div>
              <div>
                <br />
                <button
                  @click="findOrderWrapper()"
                  class="btn btn-green"
                  :disabled="!orderParams.number || !orderParams.email || !orderParams.client_name"
                >
                  {{ $t('cs.front.withdrawal_form_find_order_button') }}
                </button>
              </div>
            <div>
              <p>
                {{ $t('cs.front.withdrawal_link_to_orders_description') }}:
                <router-link :to="{ name: 'profile.orders' }">{{ $t('cs.front.orders') }}</router-link>
              </p>
            </div>
          </div>
        </div>
        <div v-if="step === 2 && order">
          <div class="order-item" style="max-width: 25rem;">
            <h2>
              <a @click="step = 1" class="back-link" href="javascript:">
                <i class="icon icon-sm icon-arrow-left"></i> {{ $t('cs.front.back') }}
              </a> #{{ order.number }}
            </h2>
            <p>{{ order.date }}</p>
            <div
              v-for="position in order.positions"
              :key="position.id"
              class="row"
              :title2="position.options?.length ? $t('cs.front.withdrawal_position_with_options_title') : ''"
            >
              <div class="col-lg-9 pb-3">
                <div v-if="position.product" class="row align-items-center align-items-lg-start" >
                  <div
                    class="col-3"
                    :style="{opacity: position.options?.length ? 0.45 : 1}"
                  >
                    <router-link
                      :to="{ name: 'product', params: { productId: position.product.id }}"
                      class="img"
                      target="_blank"
                    >
                      <img :src="position.product.image" alt="">
                    </router-link>

                  </div>
                  <div
                    class="col-9"
                    :style="{opacity: position.options?.length ? 0.45 : 1}"
                  >
                    <router-link
                      :to="(!position.cs_product || !position.cs_product.deleted_at) ?
              { name: 'product', params: { productId: position.product.id }} : '#'"
                      class="name"
                      target="_blank"
                    >
                      {{ position.product.name }}
                    </router-link>
                    <div class="id">
                      {{ $t('cs.front.product_number') }}.: {{ position.product.number }}
                    </div>
                    <div v-if="position.options.length" class="cart-position-options">
                      <div class="positions-title">
                        <u>{{ $t('cs.front.cart_position_options_title') }}</u>
                      </div>
                      <div v-for="option in position.options"
                           :key="option.id"
                           class="row w-75 position-option-row"
                      >
                        <div class="col-8 option-name">{{ option.name }}</div>
                        <div class="col-4 p-0 text-right option-price">
                          {{ $filters.priceFormat(option.price, order.currency) }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-9 col-lg-3 offset-3 offset-lg-0">
                <div class="row align-items-center align-items-lg-start">
                  <div class="col-6 text-center">
                    <b>{{ position.quantity }}</b>
                  </div>
                  <div class="col-6 text-lg-right">
                    <b class="red">{{ $filters.priceFormat(position.price, order.currency) }}</b>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="order.positions.filter((p) => p.options?.length)?.length > 0" style=" background-color: yellow; padding: 0.2rem;">
              🛈 {{ $t('cs.front.withdrawal_position_with_options_hint') }}
            </div>

            <div>
              <br />
              <button
                @click="withdrawalOrderWrapper()"
                class="btn btn-green"
                :disabled2="order.positions.filter((p) => p.options?.length <= 0)?.length <= 0"
              >
                {{ $t('cs.front.withdrawal_form_cancel_order_button') }}
              </button>
            </div>
          </div>
        </div>
        <div v-if="step === 3">
          <h2>
            <a @click="step = 1" class="back-link" href="javascript:">
              <i class="icon icon-sm icon-arrow-left"></i> {{ $t('cs.front.back') }}
            </a> #{{ order.number }}
          </h2>
          <p>{{ order.date }}</p>
          <br />
          <p class="alert alert-success">{{ $t('cs.front.withdrawal_success_message') }}</p>
        </div>
      </section>
    </div>
  </main>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import * as orderConsts from '@/consts/order';

export default {
  components: {

  },
  data() {
    return {
      orderParams: {
        client_name: '',
        number: '',
        email: '',
      },
      step: 1,
    };
  },
  computed: {
    ...mapGetters({
      order: 'order/selected',
      me: 'profile/me',
      shop: 'shop/selected',
    }),
    currentYear() {
      return new Date().getFullYear();
    },
    anonProfile() {
      const raw = localStorage.getItem('anonProfile');

      if (!raw) return null;

      try {
        return JSON.parse(raw);
      } catch {
        return null;
      }
    },
  },
  watch: {

  },
  methods: {
    ...mapActions('order', {
      findOrder: 'findOrderForWithdrawal',
      withdrawalOrder: 'withdrawalOrder',
    }),
    ...mapActions('profile', {
      fetchMe: 'fetchMe',
    }),
    findOrderWrapper() {
      this.$store.commit('showLoader');
      this.findOrder(this.orderParams).then(() => {
        if (this.order && this.order?.id) {
          this.step = 2;
        }
      }).finally(() => {
        if (!this.order || !this.order?.id) {
          this.$toast.error(this.$t('cs.front.withdrawal_order_not_found_message', { withdrawal_period: this.shop.withdrawal_period }));
        }

        this.$store.commit('hideLoader');
      });
    },
    withdrawalOrderWrapper() {
      // if (this.order.positions.filter((p) => p.options?.length <= 0)?.length <= 0) {
      // return false;
      // }

      this.$store.commit('showLoader');
      this.withdrawalOrder(this.orderParams)
        .then(() => {
          // eslint-disable-next-line vue/no-mutating-props
          this.order.status = orderConsts.STATUS_CANCELED;
          this.$emit('cancelled');
          this.step = 3;
          this.orderParams.number = '';
        })
        .finally(() => this.$store.commit('hideLoader'));

      return true;
    },
  },
  created() {
    this.$store.commit('showLoader');
    this.fetchMe().finally(() => {
      if (this.me) {
        this.orderParams.client_name = `${this.me.billing_address?.name || ''} ${this.me.billing_address?.surname || ''}`;
        this.orderParams.email = this.me.email || '';
      } else if (this.anonProfile) {
        this.orderParams.client_name = this.anonProfile.billing_address?.name
          ? `${this.anonProfile.billing_address.name}  ${this.anonProfile.billing_address.surname}`
          : '';
        this.orderParams.email = this.anonProfile.email || '';
      }

      this.$store.commit('hideLoader');
    });
  },
  mounted() {
    document.location = '#withdrawalContainer';
  },
};
</script>
